import { IForceSyncOrderStatusRule } from '../force-sync-order-status-rule.interface';

export class SuggestedForceSyncRule implements IForceSyncOrderStatusRule {
  showForceSync(): boolean {
    return false;
  }
}
